const tableTitleEquip = {
  title: 'Equipment Types',
  placeholder: 'Search'
}

export default tableTitleEquip;
